<template>
  <div>
    <p class="title-page">Portais</p>
    <TablePortals />
  </div>
</template>

<script>
import TablePortals from "../components/TablePortals.vue";

export default {
  name: "ServicosPrestados",

  components: {
    TablePortals,
  },
};
</script>
